export const CLIPBOARD_TYPE = 'dorian-node-snapshot-v1';

export interface ClipboardPayloadV1 {
  type: typeof CLIPBOARD_TYPE;
  version: 1;
  bookId: number;
  storyId: number;
  branchIds: number[];
  branchNames: string[];
}

// Phase 2: BranchSnapshot will be imported here
export interface ClipboardPayloadV2 {
  type: typeof CLIPBOARD_TYPE;
  version: 2;
  bookId: number;
  storyId: number;
  branchIds: number[];
  branchNames: string[];
  snapshot: unknown[]; // Phase 2: BranchSnapshot[]
}

export type ClipboardPayload = ClipboardPayloadV1 | ClipboardPayloadV2;
